/* eslint-disable */
import { PublisherThemeConfigProvider, PublisherThemeExtendedChakraProvider } from "theme";
import { BASE_DOMAIN } from "env";
import "../legal-styles.css";

const GLBA_URL = `https://widget.${BASE_DOMAIN}/ui/glba-notice`;
const PRIVACY_URL = `https://widget.${BASE_DOMAIN}/ui/privacy-policy`;

export const CookiesPolicyContent = () => {
  return (
    <section className="legalese">
      <div className="section-container w-container">
        <div className="center">
          <h1 className="legal-page-h1">Cookies Policy</h1>
        </div>
        <div className="rich-text-wall w-richtext">
          <p>
            <strong>Last Updated: September 23, 2022</strong>‍
          </p>
          <p>
            Tilia LLC and its affiliates (collectively “<strong>Tilia</strong>
            ”, “<strong>we</strong>
            ”, “<strong>us</strong>
            ”, “<strong>our</strong>
            ”) respect the privacy of its online visitors and users of its websites, apps, products
            and services, including communication services, (collectively, the “
            <strong>Services</strong>
            ”).
          </p>
          <p>
            When you visit or access our Services, we will use (and authorize third parties to use)
            cookies and other similar tracking technologies.  This policy (“
            <strong>Cookies Policy</strong>
            ”) explains more about how we do so and what choices are available to you.  This Cookies
            Policy forms part of our <a href={PRIVACY_URL} target="_blank">Privacy Policy</a>&nbsp;
            which describes, amongst other things, the types of information we may obtain from you
            when you use our Services, how we use the information, with whom we share it, and what
            rights and choices you have concerning that information.
          </p>
          <p>
            Cookies and other tracking technologies allow us to automatically collect information
            about you and your online behaviour in order to enhance your use of our Services,
            improve our Services performance, and customise your experience on our Services.  We
            also use this information to collect statistics about the usage of our Services, perform
            analytics, deliver content which is tailored to your interests, and administer services
            to our users, customers and partners.  We also allow third parties to collect
            information about you through cookies and other tracking technologies.{" "}
          </p>
          <p>
            <strong>What are cookies and tracking technologies, and which ones do we use?</strong>
          </p>
          <p>We use the following types of cookies and tracking technologies:</p>
        </div>
        <ul role="list" className="legal-ul">
          <li>
            <strong>Cookies</strong>: Cookies are small data files stored on your browser or device.
             They may be served by the entity that operates the website you are visiting (these are
            called“first-party cookies”) or by other companies (which are called “third-party
            cookies”).
          </li>
          <li>
            <strong>Pixels</strong>: Pixels are small images on a web page or in an email. Pixels
            collect information about your browser or device and can set cookies.
          </li>
          <li>
            <strong>Local Storage</strong>: Local storage allows data about your browser or device
            to be stored locally on your browser or device and includes HTML5local storage and
            browser cache.
          </li>
        </ul>
        <div className="rich-text-wall legal w-richtext">
          <p>
            You can find more information about cookies and tracking technologies at{" "}
            <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.
          </p>
          <p>
            <strong>How do we use these cookies and tracking technologies?</strong>
          </p>
          <p>
            More specifically, the purposes for which we and our partners use cookies and similar
            technologies generally fall into the following categories:
          </p>
        </div>
        <ul role="list" className="legal-ul">
          <li>
            <strong>Strictly necessary</strong>: These cookies and tracking technologies are
            essential to enable you to login, navigate around and use the features of our Services,
            or to provide a service requested by you (such as your username).  We do not need to
            obtain your consent in order to use these cookies and tracking technologies.  These
            cookies and tracking technologies can be used for security and integrity reasons - for
            example to detect violation of our policies and for support or security features.
          </li>
          <li>
            <strong>Functionality</strong>: These cookies and tracking technologies allow our
            Services to remember choices you make (such as your language) and provide enhanced and
            personalized features.  For example, these cookies and tracking technologies are used
            for authentication (to remember when you are logged-in) and support other features of
            our Services.
          </li>
          <li>
            <strong>Performance</strong>: These cookies and tracking technologies collect
            information about your online activity (for example the duration of your visit on our
            Services), including behavioural data and content engagement metrics.  These cookies and
            tracking technologies are used for analytics, research and to perform statistics (based
            on aggregated information).
          </li>
          <li>
            <strong>Marketing or Advertising</strong>: These cookies and tracking technologies are
            used to deliver tailored offers and advertisements to you, based on your derived
            interests, as well as to perform email marketing campaigns.  They can also be used to
            limit the number of times you see an advertisement as well as help measure the
            effectiveness of the advertising campaign.  They are usually placed by our advertisers
            (for example advertising networks) and provide them insights about the people who see
            and interact with their ads, visit their websites or use their app.These cookies and
            tracking technologies collect information about your online activity (for example the
            duration of your visit on our Services), including behavioural data and content
            engagement metrics.  These cookies and tracking technologies are used for analytics,
            research and to perform statistics (based on aggregated information).
          </li>
        </ul>
        <p>
          <strong>What information do we collect through cookies and tracking technologies?</strong>
        </p>
        <ul role="list" className="legal-ul">
          <li>
            <strong>Information about how you access the Services</strong>: When you use the
            Services, we automatically collect or receive some information about how you access the
            Services, including the device type, operating system, and browser you use, and how fast
            or stable your internet connection is.  The information we receive depends on the device
            you are using and which Services you access.
          </li>
          <li>
            <strong>Information about your activity on the Services</strong>: Information about your
            interactions with content viewed, and information about your interactions with email
            messages we send you, such as which links you click on, and whether the messages were
            opened or forwarded.
          </li>
          <li>
            <strong>Unique identifiers</strong>: IP addresses associated with the devices you use to
            access the Services, Advertising IDs, Cookie IDs, and other unique identifiers.
          </li>
        </ul>
        <p>
          The information we access through cookies and tracking technologies is processed in
          accordance with our{" "}
          <a href={PRIVACY_URL} target="_blank">
            Privacy Policy
          </a>
          .<br />
          <br />
          <strong>How to manage your cookie and tracking technology settings</strong>
          <br />
          <br />
          There are various ways in which you can manage and control your cookie and tracking
          technology settings.  Please remember that, by deleting or blocking cookies or tracking
          technologies, some of the features of the Services may not work properly or as
          effectively.
        </p>
        <ul role="list" className="legal-ul">
          <li>
            <strong>
              For individuals located in the European Economic Area (EEA) and in the UK and in
              Switzerland
            </strong>
            : You may change your consent choices within our consent management platform, which is
            also referred to as a “CMP”.  Our consent management platform is managed by a third
            party and will appear as a pop-up/banner for certain users when they first access out
            Services.  Note that this consent management platform is set to appear only for
            EEA/UK/Switzerland-based IP addresses as detected via a third-party service.
          </li>
          <li>
            <strong>Turning off cookies via your web browser</strong>: Most web browsers will
            provide you with some general information about cookies and tracking technologies,
            enable you to see what cookies and tracking technologies are stored on your device,
            allow you to delete them all or on an individual basis, and enable you to block or allow
            cookies and tracking technologies for all websites or individually selected websites.
             You can also normally turn off third-party cookies and tracking technologies
            separately. Please note that the settings offered by a browser or device often only
            apply to that particular browser or device. Information about cookies and tracking
            technologies is usually found in the &quot;Help &quot;section of the web browser. Below
            are some links to some commonly used web browsers:
          </li>
          <li className="sub-list-item">
            <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank">
              Chrome
            </a>
          </li>
          <li className="sub-list-item">
            <a
              href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
              target="_blank"
            >
              Internet Explorer and Microsoft Edge
            </a>
          </li>
          <li className="sub-list-item">
            <a
              href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
              target="_blank"
            >
              Mozilla Firefox
            </a>
          </li>
          <li className="sub-list-item">
            <a
              href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
              target="_blank"
            >
              Safari
            </a>
          </li>
          <li>
            <strong>Turning off third-party cookies and tracking technologies</strong>: You can turn
            off certain third-party targeting/advertising cookies and tracking technologies by
            visiting the following link:{" "}
            <a href="http://www.networkadvertising.org/choices/" target="_blank">
              Network Advertising Initiative
            </a>
            .
          </li>
          <li>
            <strong>Opt-out of analytics</strong>: Blocking cookies and tracking technologies in
            your web browser may not prevent cross-site tracking of your online activity using other
            online tracking technologies.  In addition to managing your cookie and tracking
            technologies settings for your browser, you can opt-out of tracking directly with the
            businesses that operate the tracking technologies.  To opt-out of certain analytic
            tracking by our partners, you may visit the links below (please note this list is not
            exhaustive):
          </li>
          <li className="sub-list-item">
            Google Analytics:{" "}
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
              https://tools.google.com/dlpage/gaoptout
            </a>
          </li>
        </ul>
        <p>
          <strong>Contact us</strong>
          <br />
          <br />
          If you have a comment or question about this Cookies Policy, please send an e-mail to{" "}
          <a href="mailto:privacy@tilia.io?subject=Tilia%20Privacy%20Policy%20%7C%20Website%20Cookies">
            privacy@tilia.io
          </a>&nbsp;
          or write to us at:
          <br />
          <br />
          Tilia LLC
          <br />
          Attention: Privacy
          <br />
          8605 Santa Monica Blvd, PMB 59201
          <br />
          West Hollywood, California 90069
        </p>
      </div>
    </section>
  );
};

const CookiesPolicy = () => {
  return (
    <PublisherThemeConfigProvider>
      <PublisherThemeExtendedChakraProvider>
        <CookiesPolicyContent />
      </PublisherThemeExtendedChakraProvider>
    </PublisherThemeConfigProvider>
  );
};

export default CookiesPolicy;
